import React from 'react';
import Formatter from '../../../formatter';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
/** @type {import('../types').DataType<import('./types').ProjectBasicModel>} */

var PROJECT_DATA_TYPE = {
  data: {
    url: '/backend/communicationsProjects',
    itemUrl: '/backend/communications/{id}',
    dataKey: 'projects',
    idKeyProp: 'Id',
    filterUrlKey: 'searchName',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView' && options.dataProps) {
        if (options.dataProps.type === 'interactive') {
          return {
            url: '/backend/communications',
            query: {
              communicationType: options.dataProps.type
            }
          };
        }

        var filter = {};
        if (options.dataProps.tags) filter['tags'] = options.dataProps.tags.join(',');
        return {
          query: filter
        };
      }
    }
  },
  columns: [{
    id: 'Name',
    children: 'Project',
    label: 'Project',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "project",
        data: data
      });
    },
    serverSort: true,
    modes: ['detail'],
    serverFilter: true
  }, {
    id: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    },
    modes: ['detail']
  }, {
    id: 'Name',
    children: 'Project',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "project",
        data: data,
        color: "inherit"
      });
    },
    serverSort: true,
    modes: ['list'],
    serverFilter: true
  }],
  thumbnail: {
    url: function url(data) {
      return data.PreviewFilePath ? getFileThumbnailPath({
        path: data.PreviewFilePath,
        workspace: data.Workspace,
        token: data.ResourceToken
      }) : null;
    },
    text: function text(data) {
      return data.Name;
    },
    icon: function icon(data) {
      return data.Type;
    } // component: 'a',
    // componentProps: data => ({ href: 'https://google.com' }),

  },
  placeholders: {
    label: function label(data) {
      return data ? data.Name : '';
    },
    type: 'project',
    icon: function icon(data) {
      if (!data) return 'project';
      return data.Type;
    }
  },
  contextMenu: [{
    type: 'delete'
  }]
};
export default PROJECT_DATA_TYPE;